'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { getZakelijkUrl } from '@/lib/urls';
import { DynamicLink } from './DynamicLink';

export function ConsumerHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container-site">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link href="/" className="flex items-center">
            <Image
              src="/images/logo.svg"
              alt="ValBewust"
              width={300}
              height={70}
              className="h-14 w-auto"
              priority
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            <Link href="/" className="text-lg text-ink/70 hover:text-ink transition-colors">
              Home
            </Link>
            <Link href="/#download" className="text-lg text-ink/70 hover:text-ink transition-colors">
              De App
            </Link>
            <Link href="/blog" className="text-lg text-ink/70 hover:text-ink transition-colors">
              Blog
            </Link>
            <Link href="/contact" className="text-lg text-ink/70 hover:text-ink transition-colors">
              Contact
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-6">
            <DynamicLink
              getHref={() => getZakelijkUrl()}
              className="text-ink/70 hover:text-ink transition-colors"
            >
              Voor Professionals
            </DynamicLink>
            <Link href="/#download" className="btn-primary text-lg py-3 px-8">
              Download App
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-3"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-gray-100">
            <nav className="flex flex-col gap-4">
              <Link
                href="/"
                className="text-xl text-ink/70 hover:text-ink transition-colors py-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                href="/#download"
                className="text-xl text-ink/70 hover:text-ink transition-colors py-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                De App
              </Link>
              <Link
                href="/blog"
                className="text-xl text-ink/70 hover:text-ink transition-colors py-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                href="/contact"
                className="text-xl text-ink/70 hover:text-ink transition-colors py-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <DynamicLink
                getHref={() => getZakelijkUrl()}
                className="text-lg text-primary-500 hover:text-primary-600 transition-colors py-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                Voor Professionals →
              </DynamicLink>
              <Link
                href="/#download"
                className="btn-primary text-center text-lg mt-4 py-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                Download App
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
